import React, { useState } from "react";
import Index from "./Index";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toFixedWithoutRounding } from "../../Utils/Toast";
import ChangePassword from "./ChangePassword";
import ProfileComp from "./ProfileComp";
import Affiliate from "./Affiliate";
import moment from "moment";
import ReferenceProfileForm from "./ReferenceProfileForm";
import UnavailableFeatureDialog from "../../component/UnavailableFeatureDialog";

const Profile = ({ setTab, embedded = false }) => {
  const navigate = useNavigate();

  const amounutRefresh = useContextSelector(
    AuthContext,
    (ctx) => ctx.amounutRefresh
  );
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const refreshAmountLoader = useContextSelector(
    AuthContext,
    (ctx) => ctx.refreshAmountLoader
  );
  const logoutUser = useContextSelector(AuthContext, (ctx) => ctx.logoutUser);

  const [show, setShow] = useState("");
  const [feature, setFeature] = useState(null);
  const [balanceVisible, setBalanceVisible] = useState(true);
  return (
    <div id="mc_container" className="security-center clear-float EN">
      {feature && <UnavailableFeatureDialog feature={feature} onClose={() => setFeature(null)} />}
      <div className="outer-casing overflow">
        <div className="information-wrap personal-information js_personal hasVip auto">
          <div className="information-top">
            <div className="vipicon" />
            <div className="upper-right">
              <div className="info-img">
                <div
                  className="first-name active"
                  style={{
                    "background-image":
                      'url("/assets/Icon/0.webp")',
                  }}
                >
                  -
                </div>
              </div>
              <div className="info-left">
                <div className="info-level-wrap">
                  <div className="vip-label">
                    <span className="vipicon" />
                    <span className="level-name">VIP0</span>
                  </div>
                  <span className="info-siginin hide" />
                </div>
                <div className="nickname-wrap">
                  <label
                    data-key="nickname"
                    className="ellipsis information-nickname"
                  >
                    {user?.user?.username || user?.username || "—"}
                  </label>
                  <div className="edit-icon" />
                  <div className="reference-profile-joined">Joined {profileData?.createdAt ? moment(profileData.createdAt).format("YYYY-MM-DD") : "—"}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="copy-wrap">
            <div className="copy-btn">
              <label data-key="username-copy" className="username-copy">
                {user?.user?.username || user?.username || "—"}
              </label>
              <div className="copy-icon" />
            </div>
          </div>
          <div className="information-money auto">
            <div className="amount-wrap">
              <div className="money-view js_sumBalance">
                <span className="symbol front">৳</span>{" "}
                <span className="balance-amount">
                  {balanceVisible ? Number(userCoins?.balance || 0).toFixed(2) : "••••"}
                </span>
              </div>
              <button type="button" aria-label="Refresh balance" className="refresh" id="refresh" onClick={amounutRefresh} />
              <button type="button" className={`eyes-icon${balanceVisible ? "" : " icon-eyes-close"}`} aria-label={balanceVisible ? "Hide balance" : "Show balance"} onClick={() => setBalanceVisible(value => !value)} />
            </div>
          </div>
          <div className="reference-profile-processing">
            <div><i aria-hidden="true">▣</i><span>{profileData?.pendingDepositCount ?? "—"} deposit request processing.<small>{moment().format("DD/MM/YYYY")}</small></span></div>
            <div><i aria-hidden="true">▤</i><span>{profileData?.pendingWithdrawCount ?? "—"} withdrawal request processing.<small>{moment().format("DD/MM/YYYY")}</small></span></div>
            <div><i aria-hidden="true">✓</i><span>Last Login Time: {profileData?.lastLoginTime ? moment(profileData.lastLoginTime).format("YYYY-MM-DD HH:mm:ss") : "—"}<small>Last Login IP: {profileData?.lastLoginIp || "—"}</small></span></div>
          </div>
        </div>

        <div className="reference-security-panel">
          <div className="reference-security-status">
            <div className="reference-security-ring">
              <strong>{profileData?.securityLevel || "Low"}</strong>
              <span>Security Level</span>
            </div>
            <p>
              <span className="reference-security-score">Score is <strong>{profileData?.securityScore ?? 0}</strong> points.</span><span>Your account security level is{" "}
              {profileData?.securityLevel || "Low"}</span>
            </p>
          </div>
          <div className="reference-security-recommended">
            <h3>Recommended setting</h3>
            <div>
              <button type="button" onClick={() => setShow("profile")}>
                <i className="iconinfo icon-info active" />
                <span>Personal Information</span>
              </button>
              <button type="button" onClick={() => setTab("withdraw")}>
                <i className="iconinfo icon-card active" />
                <span>Link E-wallet</span>
              </button>
              <button type="button" onClick={() => setFeature("Transaction Password")}>
                <i className="iconinfo icon-moneypwd active" />
                <span>Transaction Password</span>
              </button>
            </div>
          </div>
        </div>

        <div
          className="information-wrap account-information js_platformList ps"
          style={{ overflow: "hidden" }}
        >
          <div
            onClick={() => setShow("profile")}
            className="account-bind-item js_profile"
          >
            <div className="iconinfo icon-info active" />
            <div className="item-text">
              <div className="item-text-info">
                <label translate="label_setting_data">
                  Personal Information
                </label>
                <div className="icons-danger" />
              </div>
            </div>
            <div className="item-detail" translate="info_setting_profile">
              Complete the personal information to improve your account
              security.
            </div>
          </div>
          <div
            onClick={() => setShow("password")}
            className="account-bind-item js_loginPassword"
          >
            <div className="iconinfo icon-pwd active" />
            <div className="item-text">
              <div className="item-text-info">
                <label translate="label_pwd_login">Login password</label>
                <div className="icons-checked-green" />
              </div>
            </div>
            <div className="item-detail" translate="info_setting_loginPwd">
              Recommended password with combination of letters and numbers,
              mixed with uppercase and lowercase.
            </div>
          </div>
          <div
            onClick={() => setTab("withdraw")}
            className="account-bind-item js_ewallet"
          >
            <div className="iconinfo icon-card active" />
            <div className="item-text">
              <div className="item-text-info">
                <label>Link E-wallet</label>
                <div className="icons-danger" />
              </div>
            </div>
            <div className="item-detail">Link E-wallet for withdrawal.</div>
          </div>
          <div
            onClick={() => setFeature("Transaction Password")}
            className="account-bind-item js_paymentPassword"
          >
            <div className="iconinfo icon-moneypwd active" />
            <div className="item-text">
              <div className="item-text-info">
                <label>Transaction Password</label>
                <div className="icons-danger" />
              </div>
            </div>
            <div className="item-detail">
              Transaction password will use to verify your identity for any fund related operation for account safety purposes.
            </div>
          </div>
          <div
            onClick={() => logoutUser()}
            className="account-bind-item js-logout"
          >
            <div className="iconinfo icon-logout active" />
            <div className="item-text" translate="label_logout">
              Logout
            </div>
            <div className="item-detail" translate="info_setting_logout">
              Logout Safely
            </div>
          </div>
          <div className="ps__rail-x" style={{ left: "0px", bottom: "0px" }}>
            <div
              className="ps__thumb-x"
              tabIndex={0}
              style={{ left: "0px", width: "0px" }}
            />
          </div>
          <div className="ps__rail-y" style={{ top: "0px", right: "0px" }}>
            <div
              className="ps__thumb-y"
              tabIndex={0}
              style={{ top: "0px", height: "0px" }}
            />
          </div>
        </div>
      </div>
      <div className="forget-password popup">
        <div className="model-mask" />
        <div className="content" id="forget-password-content">
          <div className="close-info" translate="label_close">
            Close
          </div>
          <div className="setting-nav">
            <div className="nav-item js_bindGA hide" data-page="forgetByGa">
              <i className="iconinf-m icon-google active" />
              <div className="item-tips" translate="ga_reset_pwd">
                Google verification
              </div>
            </div>
            <div
              className="nav-item js_mobileVerified hide"
              data-page="forgetByPhone"
            >
              <i className="iconinf-m icon-phone active" />
              <div className="item-tips" translate="phone_reset_pwd">
                SMS
              </div>
            </div>
            <div className="nav-item js_email hide" data-page="forgetByEmail">
              <i className="iconinf-m icon-message active" />
              <div className="item-tips" translate="email_reset_pwd">
                Email
              </div>
            </div>
            <div className="nav-item js_customer" data-page="forgetByCustomer">
              <i className="iconinf-m icon-customer active" />
              <div className="item-tips" translate="customer_reset_pwd">
                Customer service
              </div>
            </div>
          </div>
          <div className="forget-password-wrap" />
        </div>
      </div>
      {embedded && show === "profile" && <ReferenceProfileForm profile={profileData} onClose={() => setShow("")} onUnavailable={setFeature} />}
      <div
        className={`model-case all-h ${
          (embedded ? ["password", "affiliate"] : ["profile", "password", "affiliate"]).includes(show) ? "active" : ""
        } `}
        id="js_model"
      >
        <div className="model-mask" style={{ opacity: "1" }} />
        <div
          className="setting-modal model-content clear-float"
          style={{ opacity: "1" }}
        >
          <div
            onClick={() => setShow("")}
            className="close-info"
            translate="label_close"
          >
            Close
          </div>
          <div className="setting-nav">
            <div
              onClick={() => setShow("profile")}
              className={`nav-item js_profile ${
                show == "profile" ? "active" : ""
              }`}
            >
              <i className="iconinf-m icon-info active" />
              <div className="item-tips" translate="label_setting_data">
                Personal Information
              </div>
            </div>
            <div
              onClick={() => setShow("password")}
              className={`nav-item js_loginPassword ${
                show == "password" ? "active" : ""
              }`}
            >
              <i className="iconinf-m icon-pwd active" />
              <div className="item-tips" translate="label_pwd_login">
                Login password
              </div>
            </div>
          </div>
          {show == "password" && <ChangePassword setTab={setTab} />}{" "}
          {show == "profile" && <ProfileComp setShow={setShow} />}{" "}
          {show == "affiliate" && <Affiliate setShow={setShow} />}
        </div>
      </div>
      <div className="del-card popup">
        <div className="model-mask" />
        <div className="content" id="del-card-content">
          <div className="close-info" translate="label_close">
            Close
          </div>
          <div className="setting-nav">
            <div className="nav-item js_del_password" data-page="delByPwa">
              <i className="iconinf-m icon-moneypwd active" />
              <div className="item-tips paymentTips" translate="use_pwd_del">
                Transaction Password
              </div>
            </div>
            <div className="nav-item js_del_bindGA hide" data-page="delByGa">
              <i className="iconinf-m icon-google active" />
              <div className="item-tips" translate="use_ga_del">
                Google verification
              </div>
            </div>
            <div
              className="nav-item js_del_mobileVerified"
              data-page="delByPhone"
            >
              <i className="iconinf-m icon-phone active" />
              <div className="item-tips" translate="use_phone_del">
                SMS
              </div>
            </div>
          </div>
          <div className="del-card-wrap" />
        </div>
      </div>
    </div>
  );
};

export default Profile;
